import { defineNuxtPlugin } from '#app'
import {useRegisterSW} from "virtual:pwa-register/vue";

/**
 * Needed for autoUpdate to function properly.
 * https://vite-pwa-org.netlify.app/guide/auto-update.html
 *
 * Tip: You can test the autoUpdate functionality by running npm build, then npm preview.
 * Make some changes, run npm build and preview again, and refresh the page.
 */
export default defineNuxtPlugin(() => {
    const { needRefresh, updateServiceWorker } = useRegisterSW()

    watch(needRefresh, (refresh) => {
        if (refresh) {
            updateServiceWorker(true).then(() => {
                location.reload()
            })
        }
    })
})
